import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { RequestUtilsService } from "./requestUtils";
import { GetHttpHeadersSimple } from "./serviceUtils";
import type { BusinessArea } from "../interfaces/business-area-ce.interface";
import { mapBusinessArea, mapBusinessAreas } from "./requestMapperUtils";

@Injectable({
    providedIn: "root"
})
export class BusinessAreaService {
    constructor(private requestUtils: RequestUtilsService) {}

    getAreas(): Observable<BusinessArea[]> {
        const url = "svk_businessareas?$select=svk_businessareaid,svk_name&$filter=(statecode eq 0)&$orderby=svk_name asc";
        return this.requestUtils.createGetRequest<BusinessArea[]>(url, mapBusinessAreas, GetHttpHeadersSimple);
    }

    getArea(areaId: string): Observable<BusinessArea> {
        if (!areaId) return EMPTY;
        const url = `svk_businessareas(${areaId})?$select=svk_businessareaid,svk_name`;
        return this.requestUtils.createGetRequest<BusinessArea>(url, mapBusinessArea, GetHttpHeadersSimple);
    }
}
